<template>
   <TransitionRoot appear :show="open" as="template" @keyup.esc="closeModal">
        <Dialog as="div" class="relative z-50">
            <TransitionChild as="template" appear enter="duration-300 ease-in-out" enter-from="opacity-0 bg-red-800"
                enter-to="opacity-100" leave="duration-200 ease-in-out" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed" />
            </TransitionChild>
            <div class="fixed inset-0 overflow-y-auto backdrop-blur-sm bg-black bg-opacity-20">
                <div class="flex min-h-full items-center justify-center text-center">
                    <TransitionChild as="template" appear enter="transition transform duration-300 ease-in-out"
                        enter-from="opacity-0 scale-125" enter-to="opacity-100 scale-100"
                        leave="transition transform duration-200 ease-in-out" leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-125">
                        <div class="dark:bg-gray-900 bg-stone-100 rounded-lg shadow-lg flex flex-col justify-center items-center" >
                            <section class="flex flex-col justify-center items-center px-4 py-6">
                                <div :class="borderColor()" class="border-2 w-32 h-32 p-4 flex justify-center items-center rounded-full" v-if="icon">
                                    <success class="p-4 h-full" v-if="icon == 'success'"></success>
                                    <error class="p-4 h-full" v-if="icon == 'error'"></error>
                                    <warning class="p-4 h-full" v-if="icon == 'warning'"></warning>
                                    <question class="p-4 h-full" v-if="icon == 'question'"></question>
                                </div>
                                <div class="mt-7 mb-4">
                                    <h4 v-if="content.title" class="font-medium text-2xl dark:text-white text-stone-600 mb-5">{{ content.title }}</h4>
                                    <p class="text-lg dark:text-slate-200 text-stone-500" v-if="content.message">{{ content.message }}</p>
                                </div>
                                <div class="flex w-full space-x-2">
                                    <button v-if="options.cancelButton" @click="closeModal" :class="options.cancelButtonColor" class="px-3 py-2 rounded-md transition-all duration-150 hover:-saturate-50 font-medium text-white w-full">{{ options.cancelButtonText }}</button>
                                    <button v-if="options.confirmButton" @click="confirmAction" :class="options.confirmButtonColor" class="px-3 py-2 rounded-md transition-all duration-150 hover:-saturate-50 font-medium text-white w-full">{{ options.confirmButtonText }}</button>
                                </div>
                            </section>
                            <div v-if="time" class="w-full h-1 bg-stone-400 dark:bg-slate-600 rounded-b-lg flex">
                                <div :style="`width:${progressBarWidth}%`" class="bg-stone-500 dark:bg-slate-500 h-1"></div>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
} from '@headlessui/vue'

import Success from '@/Components/Svg/Success.vue';
import Error from '@/Components/Svg/Error.vue';
import Warning from '@/Components/Svg/Warning.vue';
import Question from '@/Components/Svg/Question.vue';

const props = defineProps({
    twclass: [String, Object],
    open: {
        type: Boolean,
        default: false
    },
    icon: {
        type: String,
        default: 'warning'
    },
    time: {
        type: Number,
        default: null
    },
    content: {
        type: Object,
        default:{
            title:null,
            message:null
        }
    },
    options:{
        type: Object,
        default: {}
    },
    actions: {
        type: Object,
        default: null
    }
})

const options = computed(() => {
    return {
            cancelButton: true,
            cancelButtonText: 'Cancelar',
            cancelButtonColor: 'bg-red-500',
            confirmButton: false,
            confirmButtonText: 'Confirmar',
            confirmButtonColor: 'bg-emerald-500',
            confirmAction: closeModal,
            ...props.actions,
            ...props.options
    }
})

const timer = ref()
const updateProgressBarWidth = ref()
const progressBarWidth = ref(0)

function borderColor(){
    if(props.icon == 'success')
        return 'border-lime-400'
    if(props.icon == 'error')
        return 'border-red-500'
    if(props.icon == 'warning')
        return 'border-amber-400'
    if(props.icon == 'question')
        return 'border-sky-400'
}

const emit = defineEmits(['open'])

function confirmAction(){
    options.value.confirmAction()
    closeModal()
}

function closeModal() {
    clearTimeout(timer.value);
    emit('open')
}

function progressBar(){
    if(progressBarWidth.value >= 100){
        clearInterval(updateProgressBarWidth.value);
        progressBarWidth.value = 0
    }else{
        progressBarWidth.value++
    }
}

watch(() => props.open, () => {
    if(props.open){
        if(props.time){
            timer.value = setTimeout(() => {
                closeModal()
            }, props.time)
            updateProgressBarWidth.value = setInterval(() => {
                progressBar()
            }, (props.time / 100));
        }
    }
})

</script>

<style>

</style>
